import { useMemo, useState } from 'react';
import { PrizeView, usePrizesViewCreator } from '@viewCreators/prizes-view-creator';
import { ToDateTime } from '@utils/DateUtils';

const MESSAGE_TRUNCATE_LENGTH = 90;

export const formatPrizeAmount = (amount: number | null): string =>
  amount === null
    ? ''
    : Intl.NumberFormat('en-US', {
        currency: 'USD',
        style: 'currency',
        // Whole-dollar gift cards shouldn't read as "$50.00"
        minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
      }).format(amount);

export const formatPrizeDate = (receivedOn: string | null): string =>
  receivedOn ? ToDateTime(receivedOn).toFormat('LLL d, yyyy') : '';

export const truncatePrizeMessage = (message: string): string =>
  message.length > MESSAGE_TRUNCATE_LENGTH ? `${message.slice(0, MESSAGE_TRUNCATE_LENGTH).trimEnd()}…` : message;

export const usePrizesCardController = (cohortUserId: number) => {
  const { data, isLoading } = usePrizesViewCreator(cohortUserId);
  const [selectedPrize, setSelectedPrize] = useState<PrizeView | null>(null);

  const prizes = useMemo(() => data || [], [data]);

  return {
    prizes,
    isLoading,
    // The card is hidden entirely until the participant has won something
    hasPrizes: prizes.length > 0,
    selectedPrize,
    openPrize: (prize: PrizeView) => setSelectedPrize(prize),
    closePrize: () => setSelectedPrize(null),
  };
};
